import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import { css } from "@emotion/react";
import { pxToRem } from "@upsun/react-component-library/src/styles/css-utils";

type SecurityTableProps = {};

const SecurityTable: React.FC<SecurityTableProps> = ({ ...props }) => {
  const smallMargin = css`
    p {
      margin-bottom: 0;
    }
  `;

  const smallerText = css`
    font-size: ${pxToRem(14)};
  `
  
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell css={smallMargin}>
            <p><strong>HIPAA</strong></p>
            <p css={smallerText}>Minimum subscription term is twelve (12) months.</p>
          </BoldCell>
          <td>+25% project value</td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default SecurityTable;
